import { render, staticRenderFns } from "./ConcernsPagination.vue?vue&type=template&id=2fc67ca8&"
import script from "./ConcernsPagination.vue?vue&type=script&lang=js&"
export * from "./ConcernsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports